<script lang="ts">
	import type { BspAutoTrackingName } from '$lib/services/tracking/googleAnalytics/events';
	import type { ClassValue } from 'svelte/elements';
	import Image from '$lib/components/atoms/image/Image.svelte';
	import ObfuscatedLink from '$lib/components/atoms/obfuscatedLink/ObfuscatedLink.svelte';
	import Icon from '$lib/components/icons/Icon.svelte';
	import { onMount, type Snippet } from 'svelte';

	interface Props {
		trackingName: BspAutoTrackingName;
		imageUrl?: string;
		title?: string;
		description?: string;
		ctaText?: string;
		ctaUrl?: string;
		icon?: string;
		class?: ClassValue;
		titleClass?: ClassValue;
		ctaClass?: ClassValue;
		children?: Snippet;
		handleMount?: (trackingName: BspAutoTrackingName) => void;
		onCtaClick?: (trackingName: BspAutoTrackingName) => void;
	}

	const {
		imageUrl,
		title,
		description,
		ctaText,
		ctaUrl,
		trackingName,
		handleMount,
		onCtaClick,
		icon = 'east',
		class: classes,
		titleClass,
		ctaClass,
		children,
	}: Props = $props();

	onMount(() => {
		handleMount?.(trackingName);
	});
</script>

<aside class={['text-sm flex py-2.5 px-4 gap-x-4', classes]}>
	{@render children?.()}
	{#if imageUrl}
		<div class="flex items-center flex-shrink-0">
			<Image
				src={imageUrl}
				alt={title ?? ''}
				width="32px"
				height="32px"
			/>
		</div>
	{/if}
	<div>
		{#if title}
			<p class={['m-0 font-bold', titleClass]}>{title}</p>
		{/if}
		{#if description}
			<p class="font-400 m-0 mt-1">{description}</p>
		{/if}
		{#if ctaText && ctaUrl}
			<div class={['mt-2.5 flex items-center text-primary underline', ctaClass]}>
				<ObfuscatedLink
					href={ctaUrl}
					target="_blank"
					rel="noopener"
					class="cursor-pointer font-400 inline-flex items-center"
					onclick={() => {
						onCtaClick?.(trackingName);
					}}
				>
					<span>{ctaText}</span>
					<Icon {icon} ariaLabel={ctaText} class="ml-1 text-current" />
				</ObfuscatedLink>
			</div>
		{/if}
	</div>
</aside>
